import { render, staticRenderFns } from "./DlgGroupUpdate.vue?vue&type=template&id=664c2c4d&scoped=true"
import script from "./DlgGroupUpdate.vue?vue&type=script&lang=js"
export * from "./DlgGroupUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664c2c4d",
  null
  
)

export default component.exports